module.exports = __webpack_public_path__ + "img/new.e4c28727.svg";